module.exports = __webpack_public_path__ + "static/img/4945_phase_function_Paper_Points.fd9be35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4945_phase_function_Paper_Points.png
// module id = NE4P
// module chunks = 0